.swal2-styled {
  box-shadow: none;
  background-size: 180% 100% !important;
  transition: all 0.4s ease-in-out !important;
  -o-transition: all 0.4s ease-in-out !important;
  -webkit-transition: all 0.4s ease-in-out !important;
  -moz-transition: all 0.4s ease-in-out !important;
  -ms-transition: all 0.4s ease-in-out !important;
  min-width: 100px !important;

  &:hover {
    background-color: unset !important;
  }

  &.swal2-confirm {
    color: var(--white-color) !important;
    background-color: var(--accent-primary) !important;
    box-shadow: none !important;

    &:hover {
      color: var(--white-color) !important;
      background-color: var(--accent-primary) !important;
      box-shadow: 0 5px 15px -4px var(--bg-theme) !important;
    }
  }

  &.swal2-cancel {
    color: var(--white-color) !important;
    background: linear-gradient(to right, #2d3641db, #000000db) !important;
    box-shadow: none !important;

    &:hover {
      background: linear-gradient(to right, #2d3641db, #000000db) !important;
      box-shadow: 0 5px 15px -4px hsla(210, 22%, 4%, 0.75) !important;
    }
  }
}

div:where(.swal2-icon).swal2-question {
  border-color: var(--warning) !important;
  color: var(--warning) !important;
}

.swal-icon {
  border: 0;
  width: 100px;
}

.swal-textarea {
  margin-top: 15px !important;
  box-shadow: none !important;
  border: 1px solid var(--border-primary) !important;
  border-radius: 4px !important;
  box-shadow: none !important;
  padding: 10px 8px;
  outline: none;
  width: 100%;
  min-height: 120px;
  font-size: var(--font-size-sm);
  transition: 0.5s all !important;

  &:focus-visible,
  &:focus {
    box-shadow: none !important;
    border: 1px solid var(--bg-theme) !important;
    box-shadow: 0 0 0.25rem 0.05rem rgba(105, 108, 255, 0.1) !important;
    padding-left: 12px !important;
  }
}

.swal-validation-error {
  color: #e30000;
  font-size: var(--font-size-xs);
  font-weight: 500;
  margin: 0 !important;
  text-align: left;
}

@media only screen and (max-width: 1750px) {
  .swal2-styled {
    height: 37px;
  }
}

.swal2-actions {
  button {
    font-size: var(--font-size-base);
    height: auto !important;
  }
}

.swal-rejection-container {
  text-align: left;
  margin-top: 15px;
  font-family: inherit;

  .swal-rejection-reason-box {
    background-color: #fff5f5;
    border: 1px solid #feb2b2;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);

    .swal-rejection-reason-label {
      display: block;
      font-weight: 600;
      color: #c53030;
      font-size: 14px;
      margin-bottom: 8px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }

    .swal-rejection-reason-text {
      margin: 0;
      color: #4a5568;
      font-size: 15px;
      line-height: 1.5;
      // font-style: italic;
    }
  }

  .swal-rejection-footer {
    margin: 0;
    color: #4a5568;
    font-size: 14px;
    text-align: center;
    font-weight: 500;
    line-height: 1.4;
  }
}